import moment from 'moment';

import { CandleData } from './types';

export const candle_default: CandleData = {
  x: moment().valueOf(),
  o: 0,
  h: 0,
  l: 0,
  c: 0,
  v: 0,
};
